import Config from "../common/Config";
import { getCookie } from "./Utils";

class Kol {  
  static kolCID = getCookie(`kola.${Config.KOL_CAMPAIGN_ID}.cid`);

  static isSignedUp = () => {
    return this.kolCID !== '';
    //return document.getElementById("kol-nudge-bar-top-frame") != null;
  }

  static getStatusURL = () => {
    return Config.KOL_STATUS_URL + `?kolid=${this.kolCID}`;
  }

}

export default Kol;